// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fe757ca5","453":"9e95cdcd","455":"03cf78e3","977":"42f42496"}[chunkId] + ".chunk.js";
};